import axios from 'axios'

const baseURL =
  process.env.REACT_APP_DEV === '1'
    ? 'http://localhost:10080/api/'
    : `${window.location.protocol}//${window.location.hostname}/api/`

export default axios.create({ baseURL })
